const sameGame = (a, b) => {
    if (!a || !b) {
        return false;
    }

    if (a.id && b.id) {
        return a.id === b.id;
    }

    return a.slug && b.slug && a.slug === b.slug;
};

export const resolveGamePromo = (game, games = [], fallbackGame = null) => {
    if (!game) {
        return null;
    }

    if (game.promo) {
        return game.promo;
    }

    const fromGames = games.find((g) => sameGame(g, game))?.promo ?? null;

    if (fromGames) {
        return fromGames;
    }

    if (fallbackGame && sameGame(fallbackGame, game)) {
        return fallbackGame.promo ?? null;
    }

    return null;
};

export const resolveActivePromo = (game, games = [], fallbackGame = null) => {
    const promo = resolveGamePromo(game, games, fallbackGame);

    if (!promo?.code) {
        return null;
    }

    if (!promo.expired_at) {
        return promo;
    }

    const expiredAt = new Date(promo.expired_at);

    if (Number.isNaN(expiredAt.getTime()) || expiredAt <= new Date()) {
        return null;
    }

    return promo;
};
